import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import OptimizedImage from "./OptimizedImage";
import staffDaniele from "@/assets/staff-daniele.webp";
import staffMarco from "@/assets/staff-marco.webp";
import staffLuca from "@/assets/staff-luca.webp";

const team = [
  {
    name: "Daniele Aloisi",
    role: "Titolare & Consulente",
    bio: "Guida l'azienda da 36 anni. Si occupa di sopralluoghi, preventivi e del rapporto diretto con ogni cliente. Risponde sempre al telefono.",
    image: staffDaniele,
    alt: "Daniele Aloisi titolare infissi Roma",
  },
  {
    name: "Ivan Aloisi",
    role: "Posatore Serramenti",
    bio: "Specializzato nella posa di infissi in PVC, alluminio e legno-alluminio. Attenzione maniacale alla pulizia e ai dettagli di finitura.",
    image: staffMarco,
    alt: "posatore infissi serramenti Guidonia",
  },
  {
    name: "Dennis Aloisi",
    role: "Fabbro & Saldatore",
    bio: "Realizza grate, cancelli e ringhiere su misura. Ogni struttura è progettata per durare, con proporzioni precise e saldature impeccabili.",
    image: staffLuca,
    alt: "fabbro lavorazioni ferro su misura Roma",
  },
];

const StaffSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="about" ref={ref} className="bg-background py-24 md:py-32 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.05] text-foreground">
            Scopri il nostro Team
          </h2>
          <p className="mt-6 text-muted-foreground text-base md:text-lg leading-relaxed font-body max-w-xl">
            Da 36 anni lavoriamo tra Roma e Guidonia con un'idea semplice: fare un lavoro pulito, puntuale e curato nei dettagli. Se cerchi qualcuno che ti segue dall'inizio alla fine, sei nel posto giusto.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {team.map((member, i) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 50 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.2 + i * 0.15 }}
              className="group"
            >
              <div className="overflow-hidden rounded-sm">
                <OptimizedImage
                  src={member.image}
                  alt={member.alt}
                  className="w-full aspect-[3/4] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
              </div>
              <h3 className="mt-5 font-heading text-xl font-semibold text-foreground">
                {member.name}
              </h3>
              <p className="mt-1 text-xs uppercase tracking-[0.2em] text-accent font-body">
                {member.role}
              </p>
              <p className="mt-3 text-sm text-muted-foreground font-body leading-relaxed">
                {member.bio}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StaffSection;